import Vue from 'vue';

export class Tc {
  constructor(categoryList, vendorsById = {}) {
    const sorted = [];
    let sortedVendors = [];
    const unsortedVendors = [];
    for (const category of categoryList) {
      if (category.position) {
        sorted[category.position] = category;
      } else {
        sorted.push(category);
      }
    }
    for (const vendor of Object.values(vendorsById)) {
      if (vendor.position != null) {
        sortedVendors[vendor.position] = vendor;
      } else {
        unsortedVendors.push(vendor);
      }
    }
    sortedVendors = sortedVendors.concat(unsortedVendors);
    this.categoryList = sorted.filter(Boolean);
    this.sortedVendors = sortedVendors.filter(Boolean);
    this.categoriesById = {};
    this.categoryTraversal(c => {
      c.vendorCount = 0;
      this.categoriesById[c.id] = c;
    });
    this.vendorsById = vendorsById;
    this.hasVendors = !(Object.keys(vendorsById).length === 0 && vendorsById.constructor === Object);
    for (const vendor of Object.values(this.vendorsById)) {
      Vue.set(vendor, 'userDefinedConsent', false);
      for (const catId of vendor.categories) {
        if (this.categoriesById[catId]) {
          this.categoriesById[catId].vendorCount++;
        }
      }
    }
  }

  categoryTraversal(fn) {
    for (const category of this.categoryList) {
      if (category.subCategories) {
        for (const subCategory of category.subCategories) {
          const result = fn(subCategory);
          if (result === false) {
            return;
          }
        }
      } else {
        const result = fn(category);
        if (result === false) {
          return;
        }
      }
    }
  }

  getCategoriesConsent() {
    const categories = [];
    for (const category of Object.values(this.categoriesById)) {
      if (category.consent && category.locked_value !== 1) {
        categories.push(String(category.id));
      }
    }
    return categories;
  }
  getLockedCategories() {
    const categories = [];
    for (const category of Object.values(this.categoriesById)) {
      if (category.locked_value === 1) {
        categories.push(String(category.id));
      }
    }
    return categories;
  }

  getVendorsConsent() {
    const optinVendors = [];

    for (const [id, vendor] of Object.entries(this.vendorsById)) {
      if (vendor.consent) {
        optinVendors.push(String(id));
      }
    }
    return optinVendors;
  }

  getConsents() {
    const categories = this.getCategoriesConsent();
    const optinVendors = this.getVendorsConsent();

    return { categories, optinVendors };
  }

  processNeutralVendors() {
    //For neutral vendors, we optin if at least one of its categories is optin
    for (const vendor of Object.values(this.vendorsById)) {
      if (vendor.consent === null && vendor.categories.length > 0) {
        for (const catId of vendor.categories) {
          const category = this.categoriesById[catId];
          if (category && category.consent !== null && vendor.consent !== true) {
            vendor.consent = category.consent;
          }
        }
      }
    }
  }

  hasExpressedConsents() {
    return Object.values(this.categoriesById).some(c => c.consent === null) ||
      Object.values(this.vendorsById).some(c => c.consent === null)
      ? false
      : true;
  }

  setAllConsents(value, consentCategories = ['vendors', 'purposes']) {
    const initMethods = {
      vendors: 'initVendorConsents',
      purposes: 'initPurposeConsents',
    };
    consentCategories.forEach(c => {
      const method = initMethods[c];
      this[method](() => value);
    });
  }

  initConsents(consentReducerFn = () => false) {
    this.initPurposeConsents(consentReducerFn);
    this.initVendorConsents(consentReducerFn);
  }

  initPurposeConsents(consentReducerFn = () => false) {
    for (const category of Object.values(this.categoriesById)) {
      Vue.set(category, 'consent', category.locked_value === 1 ? true : consentReducerFn(category));
    }
  }

  initVendorConsents(consentReducerFn = () => false) {
    for (const vendor of Object.values(this.vendorsById)) {
      Vue.set(vendor, 'consent', consentReducerFn(vendor));
    }
  }

  optinVendorWithCategoriesConsent() {
    const categories = this.getCategoriesConsent()
      .concat(this.getLockedCategories())
      .map(Number);
    let modifiedVendors = 0;
    this.initVendorConsents(vendor => {
      if (!vendor.userDefinedConsent) {
        const syncValue = vendor.categories.some(id => categories.includes(id));
        if (vendor.consent !== syncValue) {
          modifiedVendors++;
        }
        return syncValue;
      }
      return vendor.consent;
    });
    return modifiedVendors;
  }

  optinvendorWithLockedOnCategories() {
    const categories = this.getLockedCategories().map(Number);
    let modifiedVendors = 0;
    this.initVendorConsents(vendor => {
      if (!vendor.userDefinedConsent) {
        const syncValue = vendor.categories.some(id => categories.includes(id));
        if (vendor.consent !== syncValue) {
          modifiedVendors++;
        }
        return syncValue;
      }
      return vendor.consent;
    });
    return modifiedVendors;
  }

  enableRealTimeCategoryVendorSync() {
    const self = this;
    self.optinVendorWithCategoriesConsent();

    return new Vue({
      data() {
        return {
          categoriesById: self.categoriesById,
          vendorsById: self.vendorsById,
          categoryUnwatchFns: [],
          vendorUnwatchFns: [],
        };
      },
      created() {
        let synchingVendors = 0;

        for (const categoryId of Object.keys(this.categoriesById)) {
          const unwatchFn = this.$watch(`categoriesById.${categoryId}.consent`, () => {
            synchingVendors += self.optinVendorWithCategoriesConsent();
          });
          this.categoryUnwatchFns.push(unwatchFn);
        }
        for (const vendorId of Object.keys(this.vendorsById)) {
          const unwatchFn = this.$watch(`vendorsById.${vendorId}.consent`, () => {
            if (synchingVendors > 0) {
              synchingVendors--;
              return;
            }
            this.vendorsById[vendorId].userDefinedConsent = true;
          });
          this.vendorUnwatchFns.push(unwatchFn);
        }
      },
    });
  }

  reInitConsents(data) {
    let optinCategories;
    let optinVendors;
    if (data.hasCookie != null) {
      //new postMessage format
      if (data.hasCookie === false) {
        return;
      }
      optinCategories = data.optinCategories;
      optinVendors = data.optinVendors;
    } else {
      if (data[1].length === 0) {
        return;
      }
      optinCategories = data[0];
    }
    this.setAllConsents(false);

    for (const optinCatId of optinCategories) {
      const category = this.categoriesById[optinCatId];
      if (category && category.locked_value !== 1) {
        category.consent = true;
      }
    }

    if (optinVendors) {
      for (const optinVendorId of optinVendors) {
        const vendor = this.vendorsById[optinVendorId];
        if (vendor) {
          vendor.consent = true;
        }
      }
    }
  }
}
